/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
import { echoOptions } from './echo-options';

window.Pusher = Pusher;

/*
 * Echo is constructed only when this build has what the broadcaster needs (KALA-6439).
 *
 * pusher-js throws in its constructor without a key or a cluster. This file loads before Livewire and
 * Alpine start, so that throw left the login page blank. Without window.Echo, Livewire skips its echo
 * listeners with a console warning and the rest of the app works. A websocket that fails to connect
 * later is acceptable; a throw while the bundle loads is not.
 */
const echoConfig = echoOptions(import.meta.env);

window.Echo = echoConfig === null ? disabledEcho() : createEcho(echoConfig);

function disabledEcho() {
    console.warn('Laravel Echo is off: this build has no websocket key, host or cluster. Real-time updates will not arrive.');

    return undefined;
}

function createEcho(config) {
    try {
        return new Echo(config);
    } catch (error) {
        // The last guard, for a constructor check echoOptions() does not know about. The app must still start.
        console.error('Laravel Echo could not start, so real-time updates are off.', error);

        return undefined;
    }
}
